import React from "react";

export default function CarteSkeleton() {
  return (
    <div className="grid gap-6 lg:grid-cols-[minmax(0,1.45fr)_minmax(360px,0.85fr)]">
      <div className="h-[520px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />
      <div className="h-[520px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />
    </div>
  );
}